import React, { useEffect, useState } from 'react';
import { Affix, Button, Card, Divider, message, Result, Row } from 'antd';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';
import moment from 'moment';
import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import Language from './tabs/Language';
import {
  getNewsByIdAction,
  getNewsCompleteByIdAction,
  saveNewsAction,
} from '../../../actions/AppCms/NewsActions';
import { history } from '../../../utils/history';
import Authorized from '../../../components/Authorization/Authorized';
import AuditTrail from '../../../components/AuditTrail/AuditTrail';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';
import { useTranslation } from 'react-i18next';

const AddNews = ({ match, form }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(); 

  const [finished, setFinished] = useState(false);
  const [itemId, setItemId] = useState(0);

  const { news, cmsLanguageList } = useSelector(store => ({
    news: store.newsReducer.news,
    cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
  }));

  useEffect(() => {
    dispatch(getCmsLanguagesAction());
    const { id } = match.params;
    setItemId(id);

    if (id > 0) {
      dispatch(getNewsByIdAction(id));
    }
  }, []);

  const handleGoReports = () => {
    history.push('/news');
  };

  const handleGoAddNew = () => {
    history.push('/add-news');
  };

  const handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        const content = [];
        cmsLanguageList.map(item => {
          content.push({
            title: fieldsValue['title-' + item.isoLanguage.code],
            description: fieldsValue['description-' + item.isoLanguage.code],
            language: item.isoLanguage.code,
          });
          return null;
        });

        const values = {
          content,
          image: fieldsValue.image ? fieldsValue.image[0] : null,
          date: moment(fieldsValue.date, 'YYYY-MM-DD'),
          published: fieldsValue.published,
        };

        if (itemId > 0) {
          dispatch(saveNewsAction(values, itemId)).then(() => {
            message.success(t('appCms.news.successfullySaved'));
            setFinished(true);
          });
        }
      }
    });
  };

  const getFormData = (newsData, lang) => {
    const result =
      newsData &&
      newsData.data.content.filter(obj => {
        return obj.language === lang;
      });
    return result ? result[0] : result;
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 16 },
      lg: { span: 12 },
    },
  };

  return (
    (<CustomAddNewPageContent
      title={t('appCms.news.updateNews')}
      subTitle={t('appCms.news.news')}
    // exportButton={
    //   <Button type="primary" onClick={() => handleExport()}>
    //     Export PDF
    //   </Button>
    // }
    >
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Form {...formItemLayout} onSubmit={handleSubmit}>
          <Card
            title={t('appCms.general')}
            bordered={false}
            extra={
              <Affix offsetTop={10}>
                <Authorized asset="appcms" operation="write">
                  <Button type="primary" htmlType="submit">
                    {t('common.save')}
                  </Button>
                </Authorized>
              </Affix>
            }
          >
            <General form={form} formData={news} submit={handleSubmit} />
          </Card>
          {cmsLanguageList.map(item => (
            <Card
              key={item.isoLanguage.code}
              title={
                item.isoLanguage.code +
                (item.defaultInMobileApp ? ` (${t('appCms.default')})` : '')
              }
            >
              <Language
                form={form}
                langCode={item.isoLanguage.code}
                language={item}
                formData={getFormData(news, item.isoLanguage.code)}
              />
            </Card>
          ))}
          <Authorized asset="appcms" operation="write">
            <Divider />
            <Row type="flex" justify="center">
              <Button type="primary" htmlType="submit">
                {t('common.save')}
              </Button>
            </Row>
            <Divider />
            <AuditTrail objectId={itemId} objectType="news" />
          </Authorized>
        </Form>)
      )}
      {finished && (
        <Result
          status="success"
          title={t('appCms.news.successfullySaved')}
          // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
          extra={[
            <Button type="primary" key="console" onClick={handleGoReports}>
              {t('appCms.news.goToNews')}
            </Button>,
            <Button key="buy" onClick={handleGoAddNew}>
              {t('appCms.news.addNews')}
            </Button>,
          ]}
        />
      )}
      {/* {exportButtonClicked && (
          <NewsPdf
            report={newsComplete}
            callback={this.exportCallBack}
          />
        )} */}
    </CustomAddNewPageContent>)
  );
};

AddNews.propTypes = {
  form: PropTypes.object,
  saveNewsAction: PropTypes.func,
  getNewsByIdAction: PropTypes.func,
  match: PropTypes.object,
  news: PropTypes.object,
  newsComplete: PropTypes.object,
  getNewsCompleteByIdAction: PropTypes.func,
};

const WrappedNewsForm = Form.create({
  name: 'WrappedNews',
})(AddNews);

function mapStateToProps({ newsReducer }) {
  const { news, newsComplete } = newsReducer;
  return { news, newsComplete };
}

const WrappedAddNews = connect(mapStateToProps, {
  saveNewsAction,
  getNewsByIdAction,
  getNewsCompleteByIdAction,
})(WrappedNewsForm);

export default WrappedAddNews;
